import { getContactList } from '@/services/contact'
import { userInfoAtom } from '@/store/root'
import { attachFormat } from '@/utils'
import u143 from '@i/global/u143.png'
import logo from '@i/global/u168.png'
import u169 from '@i/global/u169.png'
import u186 from '@i/global/u186.png'

const Footer = () => {
  const userInfo = useAtomValue(userInfoAtom)

  const { data } = useQuery({
    queryKey: ['页面底部'],
    queryFn: () => getContactList(),
    select: res => {
      if (isValidRes(res)) {
        return res.data
      }
    },
  })

  return (
    <footer className="relative h-300px text-#fff">
      <div className="container">
        <div className="h-90px flex items-center border-b border-b-#04b7ca">
          <div className="w-696px text-28px text-white font-bold">
            <img alt="天福契约" className="w-118px" src={logo} /> 天福契约
          </div>
          <div className="flex flex-1">
            <Link
              className="flex-1 text-16px transition-transform duration-300 hover:scale-105 hover:text-#fff"
              to="/products"
            >
              服务产品
            </Link>
            <Link
              className="flex-1 text-16px transition-transform duration-300 hover:scale-105 hover:text-#fff"
              to="/about"
            >
              关于我们
            </Link>
            <Link
              className="flex-1 text-16px transition-transform duration-300 hover:scale-105 hover:text-#fff"
              to="/profile"
            >
              个人主页
            </Link>
            <Link
              className="flex-1 text-16px transition-transform duration-300 hover:scale-105 hover:text-#fff"
              to="/manage"
              onClick={() => {
                if (!userInfo) {
                  message.warning('未登录，请先登录后再查看')
                  return false
                } else if (userInfo?.isReal !== 1) {
                  message.warning('未实名，请先实名后再查看')
                  return false
                } else if (userInfo?.idInTypeList && userInfo.idInTypeList.filter(n => n.type > 1).length < 1) {
                  message.warning('当前账号未加入代理商或服务商，请先加入后再查看')
                  return false
                }
              }}
            >
              服务后台
            </Link>
          </div>
        </div>
        <div className="mb-10px mt-30px h-140px flex">
          <div className="w-670px flex border-b border-b-#04b7ca">
            <div className="flex-1">
              <div className="text-16px font-700">联系方式</div>
              {data?.contacts?.map(item => (
                <div key={item.id} className="mt-20px">
                  <img className="mr-2 w-24px" src={attachFormat(item?.icon)?.[0]?.url} />
                  {item.label}：
                  <span className={clsx(item.label?.includes('24') ? 'text-#ffc21e' : '')}>{item.value}</span>
                </div>
              ))}
            </div>
            <div className="flex-1">
              <div className="text-16px font-700">友情链接</div>
              {data?.links?.map(item => (
                <div key={item.id} className="mt-20px">
                  <a href={item.value} target="_blank">
                    {item.label}
                  </a>
                </div>
              ))}
            </div>
          </div>
          <div className="flex flex-1 items-center">
            <div className="flex flex-1 flex-col items-center text-14px">
              <img className="mb-2 w-120px" src={u143} />
              微信小程序
            </div>
            <div className="flex flex-1 flex-col items-center text-14px">
              <img className="mb-2 w-120px" src={u169} />
              95154微信客服
            </div>
            <div className="flex flex-1 flex-col items-center text-14px">
              <img className="mb-2 w-120px" src={u169} />
              95154微信公众号
            </div>
          </div>
        </div>
        <div className="flex items-center text-12px">
          © Copyright 2025-至今 天福契约&nbsp;&nbsp;
          <img className="mr-1 w-15px" src={u186} />
          <a href="https://beian.mps.gov.cn/#/query/webSearch?code=32011502013294" rel="noreferrer" target="_blank">
            苏公网安备32011502013294号
          </a>
          &nbsp;&nbsp;
          <a href="https://beian.miit.gov.cn/ " rel="noreferrer" target="_blank">
            苏ICP备2025157134号-1
          </a>
        </div>
      </div>
    </footer>
  )
}

export default Footer
